export enum CampaignType {    
    MailedOut = 1,
    InHouse = 2
}